// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__1a9-A","navigationBtn":"Header_navigationBtn__18m8f","logoBtn":"Header_logoBtn__1vYfM","active":"Header_active__2B8A-"};